import { arrayOf, shape, string } from 'prop-types'

export const tagLinkShape = shape({ anchor: string, url: string })

export const tagLinkBlocksShape = shape({
  styleHeading: string,
  softwareHeading: string,
  relatedHeading: string,
  hubsHeading: string,
  styleVariants: arrayOf(tagLinkShape),
  softwareVariants: arrayOf(tagLinkShape),
  relatedTags: arrayOf(tagLinkShape),
  categoryHubs: arrayOf(tagLinkShape),
})
